import React from "react";
import SvgIcon from "@mui/material/SvgIcon";

const ArrowRightIcon = props => (
  <SvgIcon {...props}>
    <g>
      <path d="M5.59.12l13.14,11.5a.51.51,0,0,1,0,.76L5.59,23.88l-.66-.76L17.64,12,4.93.88Z" />
    </g>
  </SvgIcon>
);

export default ArrowRightIcon;
